import { InMemoryCache } from './in-memory-cache';
import { CacheHandler } from './cache-handler';
var CachedValue = /** @class */ (function () {
    function CachedValue(options) {
        this._stale = false;
        this.cacheHandler = CacheHandler.get();
        this.key = options.key;
        this.resolveData = options.resolveData;
        this.strategy = options.strategy || InMemoryCache.instance();
        this.ttl = options.ttl;
    }
    Object.defineProperty(CachedValue.prototype, "hasValue", {
        get: function () {
            return this.strategy.get(this.key) !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CachedValue.prototype, "isStale", {
        get: function () {
            return this._stale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CachedValue.prototype, "value", {
        get: function () {
            return this.strategy.get(this.key);
        },
        enumerable: false,
        configurable: true
    });
    CachedValue.prototype.evict = function () {
        this.strategy.evict(this.key);
    };
    CachedValue.prototype.get = function () {
        var _this = this;
        return this.cacheHandler
            .handle({
            cacheStrategy: this.strategy,
            evict: this._stale,
            key: this.key,
            resolveData: this.resolveData,
            ttl: this.ttl,
        })
            .then(function (result) {
            _this._stale = false;
            return result;
        });
    };
    CachedValue.prototype.markStale = function () {
        this._stale = true;
    };
    return CachedValue;
}());
export { CachedValue };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FjaGVkLXZhbHVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vbGliL2NhY2hlZC12YWx1ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0sbUJBQW1CLENBQUE7QUFDakQsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGlCQUFpQixDQUFBO0FBRTlDO0lBcUJFLHFCQUFZLE9BQXdCO1FBZDVCLFdBQU0sR0FBWSxLQUFLLENBQUE7UUFlN0IsSUFBSSxDQUFDLFlBQVksR0FBRyxZQUFZLENBQUMsR0FBRyxFQUFFLENBQUE7UUFDdEMsSUFBSSxDQUFDLEdBQUcsR0FBRyxPQUFPLENBQUMsR0FBRyxDQUFBO1FBQ3RCLElBQUksQ0FBQyxXQUFXLEdBQUcsT0FBTyxDQUFDLFdBQVcsQ0FBQTtRQUN0QyxJQUFJLENBQUMsUUFBUSxHQUFHLE9BQU8sQ0FBQyxRQUFRLElBQUksYUFBYSxDQUFDLFFBQVEsRUFBRSxDQUFBO1FBQzVELElBQUksQ0FBQyxHQUFHLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQTtJQUN4QixDQUFDO0lBbEJELHNCQUFJLGlDQUFRO2FBQVo7WUFDRSxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxTQUFTLENBQUE7UUFDbEQsQ0FBQzs7O09BQUE7SUFFRCxzQkFBSSxnQ0FBTzthQUFYO1lBQ0UsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFBO1FBQ3BCLENBQUM7OztPQUFBO0lBRUQsc0JBQUksOEJBQUs7YUFBVDtZQUNFLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFBO1FBQ3BDLENBQUM7OztPQUFBO0lBVUQsMkJBQUssR0FBTDtRQUNFLElBQUksQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQTtJQUMvQixDQUFDO0lBRUQseUJBQUcsR0FBSDtRQUFBLGlCQWNDO1FBYkMsT0FBTyxJQUFJLENBQUMsWUFBWTthQUNyQixNQUFNLENBQUM7WUFDTixhQUFhLEVBQUUsSUFBSSxDQUFDLFFBQVE7WUFDNUIsS0FBSyxFQUFFLElBQUksQ0FBQyxNQUFNO1lBQ2xCLEdBQUcsRUFBRSxJQUFJLENBQUMsR0FBRztZQUNiLFdBQVcsRUFBRSxJQUFJLENBQUMsV0FBVztZQUM3QixHQUFHLEVBQUUsSUFBSSxDQUFDLEdBQUc7U0FDZCxDQUFDO2FBQ0QsSUFBSSxDQUFDLFVBQUEsTUFBTTtZQUNWLEtBQUksQ0FBQyxNQUFNLEdBQUcsS0FBSyxDQUFBO1lBRW5CLE9BQU8sTUFBTSxDQUFBO1FBQ2YsQ0FBQyxDQUFDLENBQUE7SUFDTixDQUFDO0lBRUQsK0JBQVMsR0FBVDtRQUNFLElBQUksQ0FBQyxNQUFNLEdBQUcsSUFBSSxDQUFBO0lBQ3BCLENBQUM7SUFDSCxrQkFBQztBQUFELENBQUMsQUFwREQsSUFvREMifQ==